import gql from 'graphql-tag';

export const CREATE_CLOSE_REASON = gql`
  mutation CreateBPFCloseReason($input: CreateCloseReasonInput!) {
    bpf {
      result: createCloseReason(input: $input) {
        error
        success
        entity {
          id
          type
          label
          flowId
          isActive
          createdDateTime
          modifiedDateTime
        }
      }
    }
  }
`;
